import { QuickVideoSortKeys } from 'lib/api/quickVideo/types';

export const QUICKVIDEO_TABLE_NAMES = {
  title: 'Name',
  category: 'Category',
  test: 'Test',
  enable: 'Enable',
  actions: 'Actions',
};

export const quickVideoTableFields = [
  {
    value: 'name',
    label: QUICKVIDEO_TABLE_NAMES.title,
    sortable: true,
    sortKey: QuickVideoSortKeys.NAME,
  },
  {
    value: 'category',
    label: QUICKVIDEO_TABLE_NAMES.category,
    sortable: true,
    sortKey: QuickVideoSortKeys.CATEGORY,
  },
  {
    value: 'test',
    label: QUICKVIDEO_TABLE_NAMES.test,
    sortable: false,
    sortKey: null,
  },
  {
    value: 'enable',
    label: QUICKVIDEO_TABLE_NAMES.enable,
    sortable: false,
    sortKey: null,
  },
  {
    value: 'actions',
    label: QUICKVIDEO_TABLE_NAMES.actions,
    sortable: false,
    sortKey: null,
  },
];
